import React, { useEffect } from "react"
import { useLocalization } from "gatsby-theme-i18n";
import styled from '@emotion/styled';
import { graphql } from 'gatsby';
import MainVisual from '../sections/home/MainVisualSection';
import ProgramSection from '../sections/home/ProgramSection';
import IngameItemSection from '../sections/home/IngameItemSection';
import DigitalActivitiesSection from '../sections/home/DigitalActivitiesSection';
import OfficialGoodsSection from '../sections/home/OfficialGoodsSection'
import LatestNewsSection from '../sections/home/LatestNewsSection';
import CrosssiteBannerSection from '../sections/common/CrosssiteBannerSection';
import CountdownSection from '../sections/home/CountdownSection';
import BannerSection from '../sections/home/BannerSection';
import LatestUpdateSection from '../sections/home/LatestUpdateSection';
import HeroMessageSection from '../sections/home/HeroMessageSection';
import SponsorSection from '../sections/home/SponsorSection';
import * as breakpoint from '../styles/breakpoints.module.scss';
import AnimatedSection from '../components/AnimatedSection';

import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Seo from "../components/SEO"


const IndexPage = ({data}) => {
  const { addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('home',data.allHomeCsv.nodes);
    addString('about',data.allAboutCsv.nodes);
    addString('ingame_item',data.allIngameItemCsv.nodes);
    addString('goods',data.allGoodsCsv.nodes);
    addString('guest',data.allGuestCsv.nodes);
    addString('comment_board',data.allCommentBoardCsv.nodes);
  },[addString,data]);


  return(
    <IndexWrapper>
      <Seo 
        title={""} 
        description={data.pageDescription[localeKey]}  /> 
      <Background>
        <GatsbyImage image={getImage(data.headerBackground)} alt="bg" objectFit="cover" objectPosition="center bottom" />
      </Background>
      <MainVisual />
      <AnimatedSection>
        <LatestUpdateSection post={data.latestUpdate.edges[0].node} />
      </AnimatedSection>
      <AnimatedSection>
        <HeroMessageSection />
      </AnimatedSection>
      <BannerSection />
      <IngameItemSection />
      <AnimatedSection><CountdownSection /></AnimatedSection>
      <ProgramSection />
      <DigitalActivitiesSection />
      <OfficialGoodsSection />
      <AnimatedSection><SponsorSection /></AnimatedSection>
      <AnimatedSection><LatestNewsSection /></AnimatedSection>
      <AnimatedSection><CrosssiteBannerSection /></AnimatedSection>
    </IndexWrapper>
  );
}


export const query = graphql`
  query HomePageQuery($localePath: String!) {
    pageTitle : homeCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription :homeCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }
    pageKeywords : homeCsv(key: {regex: "/^page.keywords/"}) {
      ...localizedContent
    }

    

    allHomeCsv {
      nodes {
        ...localizedContent
      }
    }
    allAboutCsv {
      nodes {
        ...localizedContent
      }
    }
    allIngameItemCsv {
      nodes {
        ...localizedContent
      }
    }
    allGoodsCsv {
      nodes {
        ...localizedContent
      }
    }
    allGuestCsv {
      nodes {
        ...localizedContent
      }
    }
    allCommentBoardCsv {
      nodes {
        ...localizedContent
      }
    }

    headerBackground: file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_headline.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          quality: 90
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    latestUpdate : allFile(
      filter: {extension: {eq: "mdx"}, sourceInstanceName: {eq: "update"}, childrenMdx: {elemMatch: {fields: {localePath: {eq: $localePath}}}}}
      sort: {fields: childrenMdx___frontmatter___date, order: DESC}
      limit: 1
    ) {
      edges {
        node {
          childrenMdx {
            fields {
              localePath
            }
            frontmatter {
              date(formatString: "YYYY.MM.DD")
              title
            }
            slug
          }
        }
      }
    }
  }
`

export default IndexPage

const IndexWrapper = styled.div`
  padding-top:160px;
  background:#F7F7FA;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding-top:144px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding-top:128px;
  }

`

const Background = styled.div`
  position:absolute;
  height:672px;
  top:0;left:0;right:0;
  
  .gatsby-image-wrapper{
    left:0;right:0;bottom:0;
    position:absolute;
    height:100%;
    > div{
      position:absolute;
      bottom:0;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:528px;
  }


`
